<template>
  <div>
    <div class="box">
      <v-server-table 
        ref="datatableCharges" 
        :url="api" 
        :name="tableName" 
        :columns="columns" 
        :options="options">

        <template
          slot="inclusive"
          slot-scope="props">
          <span v-if="props.row.inclusive == null">
            <i class="text-muted">Not set</i>
          </span>
          <span v-if="props.row.inclusive === true">Included in price</span>
          <span v-if="props.row.inclusive === false">Added to price</span>
        </template>

      </v-server-table>

      <div 
        id="charge-popup" 
        class="modal fade inactive" 
        data-backdrop="false">
        <div class="right w-xxxl white b-l">
          <charge-form 
            ref="form" 
            :charge="charge"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from '@js/plugins/auth';
import chargeForm from './charge_form.vue';

const TableName = 'VUETABLE_CHARGE';

export default {
    components: {
        chargeForm,
    },

    data() {
        var that = this;
        let canManageTaxes = Auth.hasPermissionTo('franchise_manage_taxes');

        let actionButtons = [
            {
                title: 'Create Charge',
                action: () => {
                    this.show_popup(null);
                },
            },
        ];

        if (!canManageTaxes) {
            actionButtons = [];
        }

        return {
            charge: null,
            tableName: TableName,
            api: Laroute.route('franchise.inventory.charge.index'),
            columns: ['name', 'amount', 'inclusive', 'mode'],
            options: {
                texts: {
                    title: 'Charges',
                },

                checkbox: canManageTaxes,

                checkbox_actions: {
                    api_delete: Laroute.route(
                        'franchise.inventory.charge.delete',
                    ),
                    delete_title: 'Delete Charges',
                },

                customFilters: ['outlet_id'],
                initFilters: { outlet_id: that.$store.getters.activeOutlet },
                orderBy: { column: 'name', ascending: 1 },

                headings: {
                    inclusive: 'Charge Mode',
                },

                csv_url: Laroute.route(
                    'franchise.inventory.charge.exportAsFile',
                    { type: 'CSV' },
                ),

                pdf_url: Laroute.route(
                    'franchise.inventory.charge.exportAsFile',
                    { type: 'PDF' },
                ),

                actionButtons: actionButtons,

                rowClassCallback: row => {
                    let clazz = ['pointer'];

                    if (row.status == 0) {
                        clazz.push('text-muted');
                    }

                    return clazz;
                },

                rowClickCallback: that.show_popup,

                templates: {
                    amount(h, row) {
                        return require('../tax/amount.jsx')(h, row);
                    },

                    mode(h, row) {
                        return require('./mode.jsx')(h, row);
                    },
                },
            },
        };
    },
    computed: {
        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
        searchQuery() {
            return this.$refs.datatableCharges.query;
        },
    },

    watch: {
        activeOutlet: function() {
            this.$store.commit(`${TableName}/SET_CUSTOM_FILTER`, {
                filter: 'outlet_id',
                value: this.activeOutlet,
            });
        },
    },

    created() {
        this.init_charge();
    },

    methods: {
        init_charge() {
            this.charge = {
                id: 0,
                name: '',
                amount: '',
                inclusive: false,
                taxable: false,
                auto_assign_outlet: true,
                mode: 0,
                status: 1,
                outlets: [],
            };
        },

        get_charge(id) {
            var that = this;
            let api = Laroute.route('franchise.inventory.charge.show', {
                id: id,
            });

            this.$http.get(api).then(response => {
                let data = response.data.data;
                that.charge = data;
                that.show_modal();
            });
        },

        show_popup(row) {
            if (row != null) {
                this.get_charge(row.id);
            } else {
                var that = this;
                this.init_charge();
                setTimeout(() => {
                    this.$refs.form.clearErrorValidation();
                }, 50);
                this.show_modal();
            }
        },

        refresh() {
            this.$store.commit(`${TableName}/SET_FILTER`, this.searchQuery);
        },

        show_modal() {
            $('#charge-popup').modal('show');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/charge/vuetable_charge.vue